// istanbul ignore file
import styled from 'styled-components';

import { DOCKED_PANEL_TOP_VAR, DOCKED_PANEL_WIDTH } from '../../constants';
import { RecentDealListWrapper, StyledWrapper } from '../RecentDealsList/RecentDealsList.style';

export const DockedPanel = styled.aside`
    position: fixed;
    top: var(${DOCKED_PANEL_TOP_VAR}, 0px);
    bottom: 0;
    left: 0;
    z-index: 1000;
    width: ${DOCKED_PANEL_WIDTH};
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border-right: 1px solid #b2b2b2;
    outline: none;

    .recent-deals-title {
        font-weight: 600;
    }
    .card-header-content-container {
        padding: 9px !important;
    }

    ${RecentDealListWrapper} {
        padding: 0;

        .deal-card {
            border: none;
            border-bottom: 1px solid #b2b2b2;
        }

        .deal-card:first-child {
            border-radius: 0;
            border-top: 1px solid #b2b2b2;
        }
    }
`;

export const DockedHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 1.25rem 1rem;
`;

export const DockedTitle = styled.div`
    display: flex;
    align-items: baseline;
    gap: 0.75rem;
    min-width: 0;
    white-space: nowrap;
`;

export const DockedFilter = styled.div`
    padding: 0 1rem 0.75rem 1rem;
`;

export const DockedBody = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    ${StyledWrapper} {
        align-items: center;
    }
`;

export const DockedFooter = styled.div`
    padding: 0.5rem 1rem;
    border-top: 1px solid #b2b2b2;
    background-color: rgba(244, 244, 244, 0.96);

    .ids-action-buttons-container-rightAligned {
        background-color: transparent;
    }
`;
